import { render, staticRenderFns } from "./fireResistantStructSpecInfo.vue?vue&type=template&id=0ed57faf"
import script from "./fireResistantStructSpecInfo.vue?vue&type=script&lang=js"
export * from "./fireResistantStructSpecInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed57faf')) {
      api.createRecord('0ed57faf', component.options)
    } else {
      api.reload('0ed57faf', component.options)
    }
    module.hot.accept("./fireResistantStructSpecInfo.vue?vue&type=template&id=0ed57faf", function () {
      api.rerender('0ed57faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/frss/fireResistantStructSpecInfo.vue"
export default component.exports